/* @flow */

const SEARCH_RESULT_LAYOUT = {
    // eslint-disable-next-line @typescript-eslint/prefer-as-const
    GRID: "GRID" as "GRID",
    // eslint-disable-next-line @typescript-eslint/prefer-as-const
    LIST: "LIST" as "LIST"
};

export type SearchResultLayout = "GRID" | "LIST" | undefined;

export default SEARCH_RESULT_LAYOUT;

export const { GRID, LIST } = SEARCH_RESULT_LAYOUT;
